  var partner_slider = new Swiper('.partner_slider', {
    slidesPerView: 3,
    effect: 'coverflow',
    centeredSlides: true,
    spaceBetween: 10,
    slidesPerGroup: 1,
    loop: true,
    loopFillGroupWithBlank: false,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 200,
      modifier: 0.75,
      slideShadows: false,
    },
    breakpoints: {
      720: {
        slidesPerView: 5.5,
        spaceBetween: 50,
        loop: true,
      },
    },
  });